import {SEARCH_KEY_ALL_SEARCH_FIELDS} from "@constants/params";
import {SearchKey} from "@hooks/query/types/queryParams";

export const getCurrentSearchKey = <T>({
                                           searchKey,
                                           searchKeysArr,
                                       }: {
    searchKeysArr?: (keyof T)[],
    searchKey: SearchKey<T> | false
}): keyof T | (keyof T) [] | null => {
    if(!searchKey){
        return  null
    }
   if(!searchKeysArr?.length && searchKey !== SEARCH_KEY_ALL_SEARCH_FIELDS ){
       return  searchKey
   }
   if(searchKey === SEARCH_KEY_ALL_SEARCH_FIELDS){
       return  searchKeysArr
   }
   return  searchKey

}